import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.css']
})
export class OtpInputComponent implements  AfterViewInit {
  @ViewChild('otpInput') input!: ElementRef<HTMLInputElement>;

  @Output() onVerifyOtp = new EventEmitter();
  @Output() onValueChange = new EventEmitter<string>();

  isFocused = false;

  readonly otpLength = 6;
  otpArr = new Array(this.otpLength).fill('');
  otp='';
  // get otp(): string {
  //   return this.otpArr.join('');
  // }

  ngAfterViewInit() {
    this.focusOnInput();
  }

  focusOnInput() {
    const firstInput = this.input?.nativeElement;
    if (firstInput) firstInput.focus();
  }

  moveFocus(event: any, index: number) {
    if (event.target.value && index < this.otpLength) {
      const nextInput = event.target.nextElementSibling as HTMLInputElement;
      if (nextInput){
        nextInput.focus();
      } else{
        this.onVerifyOtp.emit();
      }
    }
  }

  onFocus(event: FocusEvent) {
    (event.target as any)?.select();
  }

  onKeyDown(event: Event, index: number) {
    if ((event as KeyboardEvent).key === 'Backspace' && !this.otpArr[index] && index > 0) {
      const prevInput = (event.target as HTMLElement).previousElementSibling as HTMLInputElement;
      if (prevInput) prevInput.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text').trim();


    if (pastedData) {
      for (let i = 0; i < this.otpLength; i++) {
        if (pastedData[i]) {
          this.otpArr[i] = pastedData[i];
        }
      }

      this.otp = this.otpArr.join('');
    }
  }

  onValueChangeEvent(event: Event) {
    this.onValueChange.emit(this.otp);

    if (this.otp.length === this.otpLength) {
      this.onVerifyOtp.emit();
    }
  }
}
